// ----------------------------------------------------------------------------- //
//  Toggle Body Overflow
// ----------------------------------------------------------------------------- //
export default function toggleBodyOverflow() {

	const toggleOverflow = document.querySelectorAll('.js-body-overflow');

	if ( toggleOverflow.length ) {
		toggleOverflow.forEach( (btn) => {
			btn.addEventListener("click", () => {
				if ( ! document.body.classList.contains("overflow-hidden") ) {
					document.body.classList.add("overflow-hidden");
				} else {
					document.body.classList.remove("overflow-hidden");
				}
			});
		});
	}
};
